// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    /* overflow: auto !important; */
}

.ProcessingPolicy-module__headerBox--Z0HLo {
    display: flex;
    padding: 10px 10px 30px 10px;
    /* background-color: #EDF1F7;  */
}

.ProcessingPolicy-module__border--xbzNP {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #C7BFFF;
    padding-bottom: 20px;
    width: 100%;
}

.ProcessingPolicy-module__titleBox--dkmgY {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ProcessingPolicy-module__titleBox--dkmgY>h1 {
    color: #6F879C;
    font-size: 30px;
    font-weight: 500;
}

.ProcessingPolicy-module__titleBox--dkmgY>p {
    color: #0054E6;
    font-size: 15px;
    font-weight: 300;
}

.ProcessingPolicy-module__contentBox--YsU45 {
    width: 80%;
    margin: 0 auto;

}

.ProcessingPolicy-module__filesBox--xQTK0 {
    border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    padding: 20px;
}

.ProcessingPolicy-module__FileItemBorder--YJuo0 {
    display: flex;
    border-bottom: 1px solid #C7BFFF;
    align-items: center;
    gap: 20px;
    margin: 10px;
}

.ProcessingPolicy-module__FileItem--uMk4Z {
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 10px;
}

.ProcessingPolicy-module__FileItemBorder--YJuo0>a,
.ProcessingPolicy-module__FileItem--uMk4Z>a {
    color: #6F879C;
    font-size: 18px;
    font-weight: 500;
    text-decoration: none;
}

.ProcessingPolicy-module__btnBack--F2RsM {
    text-transform: none !important;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 70px;
    gap: 10px;
    color: #0054E6 !important;
}

.ProcessingPolicy-module__mt10--Wn1DI {
    margin-top: 10px;
}

.ProcessingPolicy-module__textContent--vX1eW {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 30px;
}

.ProcessingPolicy-module__textBox--GwtUi {
    border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    padding: 20px;
}

.ProcessingPolicy-module__itemText--ZOUm6>h3 {
    color: #6F879C;
    font-size: 20px;
    font-weight: 500;
}

.ProcessingPolicy-module__itemText--ZOUm6>p>span {
    color: #0054E6;
}

@media (max-width: 430px) {
    .ProcessingPolicy-module__titleBox--dkmgY {
        width: 250px;
        flex-direction: column;
    }

    .ProcessingPolicy-module__border--xbzNP {
        flex-direction: column;
    }

    .ProcessingPolicy-module__FileItem--uMk4Z>a {
        width: 130px;
    }
    .ProcessingPolicy-module__FileItemBorder--YJuo0 > a {
        padding-bottom: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/processing-policy/ui/ProcessingPolicy.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;;AAElB;;AAEA;IACI,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;IACnD,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;IACnD,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;IACA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["body {\r\n    margin: 0;\r\n    padding: 0;\r\n    /* overflow: auto !important; */\r\n}\r\n\r\n.headerBox {\r\n    display: flex;\r\n    padding: 10px 10px 30px 10px;\r\n    /* background-color: #EDF1F7;  */\r\n}\r\n\r\n.border {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-bottom: 1px solid #C7BFFF;\r\n    padding-bottom: 20px;\r\n    width: 100%;\r\n}\r\n\r\n.titleBox {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.titleBox>h1 {\r\n    color: #6F879C;\r\n    font-size: 30px;\r\n    font-weight: 500;\r\n}\r\n\r\n.titleBox>p {\r\n    color: #0054E6;\r\n    font-size: 15px;\r\n    font-weight: 300;\r\n}\r\n\r\n.contentBox {\r\n    width: 80%;\r\n    margin: 0 auto;\r\n\r\n}\r\n\r\n.filesBox {\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    padding: 20px;\r\n}\r\n\r\n.FileItemBorder {\r\n    display: flex;\r\n    border-bottom: 1px solid #C7BFFF;\r\n    align-items: center;\r\n    gap: 20px;\r\n    margin: 10px;\r\n}\r\n\r\n.FileItem {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    margin: 10px;\r\n}\r\n\r\n.FileItemBorder>a,\r\n.FileItem>a {\r\n    color: #6F879C;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    text-decoration: none;\r\n}\r\n\r\n.btnBack {\r\n    text-transform: none !important;\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    height: 70px;\r\n    gap: 10px;\r\n    color: #0054E6 !important;\r\n}\r\n\r\n.mt10 {\r\n    margin-top: 10px;\r\n}\r\n\r\n.textContent {\r\n    width: 80%;\r\n    margin: 0 auto;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.textBox {\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    padding: 20px;\r\n}\r\n\r\n.itemText>h3 {\r\n    color: #6F879C;\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n}\r\n\r\n.itemText>p>span {\r\n    color: #0054E6;\r\n}\r\n\r\n@media (max-width: 430px) {\r\n    .titleBox {\r\n        width: 250px;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .border {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .FileItem>a {\r\n        width: 130px;\r\n    }\r\n    .FileItemBorder > a {\r\n        padding-bottom: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerBox": `ProcessingPolicy-module__headerBox--Z0HLo`,
	"border": `ProcessingPolicy-module__border--xbzNP`,
	"titleBox": `ProcessingPolicy-module__titleBox--dkmgY`,
	"contentBox": `ProcessingPolicy-module__contentBox--YsU45`,
	"filesBox": `ProcessingPolicy-module__filesBox--xQTK0`,
	"FileItemBorder": `ProcessingPolicy-module__FileItemBorder--YJuo0`,
	"FileItem": `ProcessingPolicy-module__FileItem--uMk4Z`,
	"btnBack": `ProcessingPolicy-module__btnBack--F2RsM`,
	"mt10": `ProcessingPolicy-module__mt10--Wn1DI`,
	"textContent": `ProcessingPolicy-module__textContent--vX1eW`,
	"textBox": `ProcessingPolicy-module__textBox--GwtUi`,
	"itemText": `ProcessingPolicy-module__itemText--ZOUm6`
};
export default ___CSS_LOADER_EXPORT___;
